import clsx from "clsx";
import { HTMLAttributes } from "react";
import styles from "./SkeletonImage.module.scss";

export type SkeletonImageProps = {
  width?: string;
  height?: string;
} & Pick<HTMLAttributes<HTMLDivElement>, "className" | "style">;

function SkeletonImage({
  className,
  height,
  width,
  style,
}: SkeletonImageProps) {
  let s: any = style ?? {};
  if (height) {
    s.height = height;
  }
  if (width) {
    s.width = width;
  }
  return <div style={s} className={clsx(styles.skeletonBox, className)}></div>;
}

export default SkeletonImage;
